import { useState, useContext, useEffect, useCallback } from "react";
import { MainContext } from "../../context/main-context";
import { datasetType } from '../../interface-type'
import { getSiteByUserId } from "../../api/vallaris/site";
import { getDatasetList } from "../../api/vallaris/dataset";
import { replaceAll } from '../use-func/util'


export const useDatasetList = () => {
  const [datasetList, setdatasetList] = useState<datasetType[] | null>(null);
  const { hostV, apikeyV, tokenV, userIdV } = useContext(MainContext);

  const loadData = useCallback(async () => {
    const rsSite = await getSiteByUserId(hostV, apikeyV, tokenV, userIdV);
    const siteId = rsSite[0].site_id;
    const rsDataset = await getDatasetList(
      hostV,
      apikeyV,
      tokenV,
      siteId,
      userIdV
    );
    if (rsDataset.length === 0) {
      setdatasetList([]);
    } else {
      const output = rsDataset.map((ds: any) => {
        return {
          id: replaceAll(ds.dataset_name, " ", "-"),
          url: [`${hostV}/tile/${ds.dataset_id}/{z}/{x}/{y}?key=${apikeyV}`],
          sourceLayer: ds.dataset_id,
          style: ds.dataset_style[0]
        };
      });
      setdatasetList(output);
    }
  }, [setdatasetList]);

  useEffect(() => {
    if (!datasetList) {
      loadData();
    }
  }, [datasetList]);

  return datasetList;
};
